import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"

export const useAuth = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        const stored = localStorage.getItem("isAuthenticated")
        return stored === "true"
    })
    const [user, setUser] = useState(() => {
        const stored = localStorage.getItem("user")
        return stored ? JSON.parse(stored) : null
    })

    useEffect(() => {
        // Sync localStorage with state
        if (isAuthenticated && user) {
            localStorage.setItem("isAuthenticated", "true")
            localStorage.setItem("user", JSON.stringify(user))
        } else {
            localStorage.removeItem("isAuthenticated")
            localStorage.removeItem("user")
        }
    }, [isAuthenticated, user])

    const login = (userData) => {
        setUser(userData)
        setIsAuthenticated(true)
        localStorage.setItem("isAuthenticated", "true")
        localStorage.setItem("user", JSON.stringify(userData))
    }

    const logout = () => {
        setUser(null)
        setIsAuthenticated(false)
        localStorage.removeItem("isAuthenticated")
        localStorage.removeItem("user")
        // Note: httpOnly cookie will be cleared by backend logout endpoint if it exists
        // For now, we just clear localStorage
    }

    const checkAuth = () => {
        const stored = localStorage.getItem("isAuthenticated")
        const storedUser = localStorage.getItem("user")
        if (stored === "true" && storedUser) {
            setIsAuthenticated(true)
            setUser(JSON.parse(storedUser))
            return true
        }
        return false
    }

    return {
        isAuthenticated,
        user,
        login,
        logout,
        checkAuth
    }
}